import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import React from "react";

import { InstantInsights } from "@/pages/channel-roi/api/getChannelROIInsights";

interface InsightCardProps {
  insight: InstantInsights;
}

export const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  const tagBackgroundColor = insight.type === "positive" ? "#E9F8F0" : "#FAD9D7";

  return (
    <Card
      sx={{
        padding: 0.5,
        borderRadius: "12px",
        boxShadow: "none",
        border: "1px solid #E0E0E0",
        width: "100%",
      }}
    >
      <CardContent>
        <Box mb={2}>
          <Chip
            label={
              <Typography color={"black"} variant="body2" sx={{ fontWeight: 600 }}>
                {insight.tagline}
              </Typography>
            }
            sx={{
              backgroundColor: tagBackgroundColor,
              py: 0.5,
              px: 0.5,
              borderRadius: "6px",
            }}
          />
        </Box>
        <Typography mb={2} variant="body2" sx={{ fontWeight: 600 }}>
          {insight.headline}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.5 }}>
          {insight.content}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InsightCard;
